import styled from "styled-components";
import { buttonHeight } from "common/const/const";

const BoxField = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: space-between;
  width: 100%;
  height: ${buttonHeight};
  border: var(--border-width) solid var(--Gray);
  border-radius: var(--border-radius-8);
  padding-inline-start: 1rem;
  padding-inline-end: 1rem;
  font-size: var(--font-size-14);
  color: var(--DarkNavy);

  cursor: pointer;
  box-sizing: border-box;
  background: transparent;
`;

const BoxFieldStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  height: auto;
`;

const BoxAreaStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  height: auto;
  min-height: 10rem;
  margin-top: 1rem;
`;

export { BoxField, BoxFieldStyle, BoxAreaStyle };
